import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconVolume2 = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--volume-2")} iconColor={color} size={size} width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

      <defs>
          <path d="M18.363,4.29278645 C18.7535833,3.90232114 19.3867482,3.90241674 19.7772135,4.293 C24.0714149,8.58849837 24.0714149,15.5515016 19.7772135,19.847 C19.3867482,20.2375833 18.7535833,20.2376789 18.363,19.8472135 C17.9724167,19.4567482 17.9723211,18.8235833 18.3627865,18.433 C21.8762239,14.9185013 21.8762239,9.22149866 18.3627865,5.707 C17.9723211,5.31641674 17.9724167,4.68325177 18.363,4.29278645 Z M12,5.07 L12,19.07 C12,19.9085062 11.0300683,20.3746795 10.375305,19.8508688 L5.64921894,16.07 L2,16.07 C1.44771525,16.07 1,15.6222847 1,15.07 L1,9.07 C1,8.51771525 1.44771525,8.07 2,8.07 L5.64921894,8.07 L10.375305,4.28913119 C11.0300683,3.76532051 12,4.23149379 12,5.07 Z M10,7.15062485 L6.62469505,9.85086881 C6.447382,9.99271925 6.2270715,10.07 6,10.07 L3,10.07 L3,14.07 L6,14.07 C6.2270715,14.07 6.447382,14.1472808 6.62469505,14.2891312 L10,16.9893752 L10,7.15062485 Z M14.833,7.82278645 C15.2235833,7.43232114 15.8567482,7.43241674 16.2472135,7.823 C18.5895052,10.1659991 18.5895052,13.9640009 16.2472135,16.307 C15.8567482,16.6975833 15.2235833,16.6976789 14.833,16.3072135 C14.4424167,15.9167482 14.4423211,15.2835833 14.8327865,14.893 C16.3943142,13.3310006 16.3943142,10.7989994 14.8327865,9.237 C14.4423211,8.84641674 14.4424167,8.21325177 14.833,7.82278645 Z" id="icon--centivo--volume-2"/>
      </defs>
      <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-87.000000, -1423.000000)"/>
          <g id="Icon/volume-2">
              <mask id="mask-2" fill="white">
                  <use xlinkHref="#icon--centivo--volume-2"/>
              </mask>
              <use id="Shape" fill="currentColor" xlinkHref="#icon--centivo--volume-2"/>
          </g>
      </g>
  </IconWrapper>
)
